webpackJsonp([0],{

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Coordinates", function() { return Coordinates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HawkeyeMap", function() { return HawkeyeMap; });
/**
 * 
 */
var _L = L,
    Control = _L.Control,
    TileLayer = _L.TileLayer,
    Map = _L.Map;
var _T = T,
    $assign = _T.assign;
/**
 * 
 */

var Coordinates = Control.extend({
  options: {
    position: 'bottomleft'
  },
  onAdd: function onAdd(map) {
    var container = T.create('span');
    var showing = function showing(latlng) {
      container.innerText = "坐标：" + latlng.lng.toFixed(4) + ", " + latlng.lat.toFixed(4);
    };
    showing(map.getCenter());
    map.on('mousemove', function (e) {
      showing(e.latlng);
    });
    return container;
  }
});
/**
 * 
 */
var HawkeyeMap = Control.extend({
  options: {
    position: 'topright'
  },
  onAdd: function onAdd(map) {
    var _this = this;

    var container = T.div();
    T(container).setStyle({
      position: 'relative',
      width: '200px',
      height: '200px',
      border: '2px solid #3D6DCC',
      borderRadius: '100px'
    });
    T.defer(function () {
      _this.createHawkeyeMap(container);
    });
    return container;
  },


  /**
  * 创建鹰眼图
  */
  createHawkeyeMap: function createHawkeyeMap(node, options) {
    var map = this._map;

    var hawkeyeMap = new Map(node, $assign({}, map.options, {
      attributionControl: false,
      zoomControl: false,
      scrollWheelZoom: false
    }));
    // hawkeyeMap.dragging.disable();
    hawkeyeMap.touchZoom.disable();
    hawkeyeMap.doubleClickZoom.disable();
    hawkeyeMap.scrollWheelZoom.disable();
    //
    var syncView = function syncView(e) {
      hawkeyeMap.setView(map.getCenter(), map.getZoom() - 2);
    },
        syncLayer = function syncLayer(e) {
      e && hawkeyeMap.eachLayer(function (layer) {
        hawkeyeMap.removeLayer(layer);
      });
      map.eachLayer(function (layer) {
        if (layer instanceof TileLayer) {
          new TileLayer(layer._url, $assign({}, layer.options)).addTo(hawkeyeMap);
        }
      });
    };
    syncLayer();
    map.whenReady(syncView);
    map.on('move', syncView);
    hawkeyeMap.on('dragend', function () {
      map.panTo(hawkeyeMap.getCenter(), { animate: false });
    });
    // todo 修改
    T.vm.map.on('provider-change', syncLayer); //
    //
    return hawkeyeMap;
  }
});

/***/ })

});


// WEBPACK FOOTER //
// widgets.js